import React from 'react'
import { useMedia } from 'sb-hooks'

import type { SvgName, SvgColor } from 'components/_new/ui'

import { Svg } from 'components/_new/ui'
import { Box } from 'components/_new/layout'
import { Button } from 'components/_new/controls'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './NoItems.scss'


export type NoItemsProps = {
  svgName?: SvgName
  svgColor?: SvgColor
  titleMessage?: ReactIntlMessage
  subTitleMessage?: ReactIntlMessage
  buttonProps?: {
    title: string | ReactIntlMessage
    to?: string
    redirect?: string
    color?: string
    onClick?: React.MouseEventHandler
    dataTestId?: string
  }
  buttonNode?: React.ReactNode
  // align to the left
  alignLeft?: boolean
  dataTestId?: string
}


const NoItems: React.FunctionComponent<NoItemsProps> = (props) => {
  const { isMobile } = useMedia()
  const {
    svgName = 'noItems', svgColor = 'gray-30',
    titleMessage = messages.title, subTitleMessage,
    buttonProps, buttonNode, alignLeft, dataTestId,
  } = props

  return (
    <Box pt={64} pb={64} alignLeft={alignLeft} alignCenter={!alignLeft} dataTestId={dataTestId}>
      <Svg className={s.image} name={svgName} color={svgColor} />
      <Box mt={40} mb={8}>
        <Text message={titleMessage} size="22-32" semibold html />
      </Box>
      {
        Boolean(subTitleMessage) && (
          <Text message={subTitleMessage} size="16-24" html />
        )
      }
      {
        Boolean(buttonNode) && (
          <Box mt={isMobile ? 40 : 24}>
            {buttonNode}
          </Box>
        )
      }
      {
        Boolean(buttonProps && buttonProps.title) && (
          <Box mt={isMobile ? 40 : 24}>
            <Button
              color={isMobile ? 'brand' : 'brandTransparent'}
              rightIcon={isMobile ? 'rightArrowSmall' : null}
              size="md"
              fullWidthOnMobile
              {...buttonProps}
            />
          </Box>
        )
      }
    </Box>
  )
}


export default NoItems
